module.exports = __webpack_public_path__ + "static/media/briefOne.c14eacd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/briefOne.png
// module id = 1736
// module chunks = 0 1